export const mockPark = [
  {
    generatorId: 'G-149|Benches|2x1',
    position: [2, 0, 4],
    rotation: 90,
  },
  {
    generatorId: 'G-101|Trees|1x1',
    position: [1, 0, 1],
  },
  {
    generatorId: 'G-101|Trees|1x1',
    position: [3, 0, 1],
  },
  {
    generatorId: 'G-101|Trees|1x1',
    position: [0, 0, 3],
  },
];
